import { useEffect, useRef } from 'react';
import type { ChatEntry } from '../../../shared/types';

interface GameFeedProps {
  entries: ChatEntry[];
}

/** Read-only feed of system/game events (dice rolls, moves, captures, wins). */
export default function GameFeed({ entries }: GameFeedProps) {
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = listRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [entries.length]);

  const log = entries.filter((e) => e.authorId === null);

  return (
    <div className="lud-glass flex h-56 flex-col overflow-hidden rounded-3xl">
      <div className="flex items-center gap-2 border-b border-white/10 px-4 py-2.5 text-xs font-bold uppercase tracking-widest text-lud-muted">
        <span className="h-2 w-2 rounded-full bg-[#ffc94d]" />
        Game log
      </div>
      <div ref={listRef} className="lud-scroll flex-1 space-y-1.5 overflow-y-auto px-4 py-3">
        {log.length === 0 ? (
          <p className="text-xs italic text-lud-muted/60">Waiting for the game to start…</p>
        ) : (
          log.map((e) => (
            <p key={e.id} className="text-xs font-semibold text-[#ffc96b] last:animate-pulse">
              {e.text}
            </p>
          ))
        )}
      </div>
    </div>
  );
}
